require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-marco-krahenbuhl.json") })
        }
      }, "path---en-interviste-marco-krahenbuhl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-marco-krahenbuhl!./.cache/json/en-interviste-marco-krahenbuhl.json
// module id = 590
// module chunks = 231608221292675